import {
  fetchUsers,
  getItemsCount,
  getItemsFromCollection,
} from "directus/src/operations";

import { applySorting } from "utils";
import { queryClient } from "utils/react-query";

export const createListQuery = (params, queryOptions = {}) => {
  const {
    endpoint,
    page = 1,
    perPage = 25,
    search = "",
    sortBy,
    sortOrder = "desc",
    filters = {},
    meta = {},
    enabled = true,
    attrs,
  } = params;

  const queryKey = [
    "clients",
    "list",
    {
      page,
      perPage,
      search,
      sortBy,
      sortOrder,
      filters,
      fields: attrs,
      filter: meta.filter,
    },
  ];

  const queryFn = async () => {
    const query = {
      deep: meta.deep,
      limit: perPage,
      page,
      search: search,
      sort: applySorting(sortBy, sortOrder),
      fields: attrs,
      filter: filters,
    };

    // Add filters to the query

    try {
      const [response, countResponse] = await Promise.all([
        getItemsFromCollection("clients", query),
        getItemsCount("clients", {
          aggregate: {
            countDistinct: ["id"],
          },
          query: { search: search, filter: query?.filter || {} },
        }),
      ]);

      return {
        items: response,
        count: countResponse?.[0]?.countDistinct.id || 0,
        meta: {},
      };
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  return {
    queryKey,
    queryFn,
    enabled: enabled,
    placeholderData: (previousData) => previousData, // Replaces keepPreviousData
    ...queryOptions,
  };
};

export const fetchListData = async (params, queryOptions = {}) => {
  const queryConfig = createListQuery(params, queryOptions);
  return await queryClient.fetchQuery(queryConfig);
};
